// src/components/Footer.jsx

import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaFacebook, FaEnvelope } from 'react-icons/fa';
import './Footer.css';

function Footer() {
  const socialLinks = [
    { 
      name: 'GitHub', 
      url: 'https://github.com/jex23', 
      Icon: FaGithub 
    },
    { 
      name: 'LinkedIn', 
      url: 'https://www.linkedin.com/in/james-galos-608826215', 
      Icon: FaLinkedin 
    },
    { 
      name: 'Facebook', 
      url: 'https://www.facebook.com/james.galos.rm.146', 
      Icon: FaFacebook 
    },
    { 
      name: 'Email', 
      url: 'mailto:jamesgalos223@gmail.com', 
      Icon: FaEnvelope 
    }
  ];

  return (
    <footer className="footer">
      <div className="footer__container">
        <motion.div 
          className="footer__content"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <div className="footer__logo">
            <span>James Galos</span>
          </div>
          
          <div className="footer__bio">
            <p>Node.js & Express | PostgreSQL & MySQL</p>
            <p>AWS EC2 / Nginx deployments | EMV-compliant payment integrations</p>
            <p>Beyond coding, I enjoy running, cycling, exploring Edge-AI projects on Raspberry Pi, building IoT systems with Arduino, and designing FPGA applications.</p>
          </div>
          
          <div className="footer__socials">
            {socialLinks.map((social, index) => {
              const IconComponent = social.Icon;
              return (
                <motion.a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.name}
                  whileHover={{ y: -5, scale: 1.1 }}
                  transition={{ duration: 0.2 }}
                  style={{ transitionDelay: `${index * 0.1}s` }}
                  className="social-link"
                >
                  <IconComponent className="social-icon" size={24} />
                </motion.a>
              );
            })}
          </div>
          
          <div className="footer__copyright">
            <p>© {new Date().getFullYear()} James Galos. All rights reserved.</p>
            <p>Built with React and ❤️</p>
          </div>
        </motion.div>
      </div>
    </footer>
  );
}

export default Footer;
